import axios from "../api";
import { objectToParam } from "../../libs/utils";

export async function getParkingRequests(registrationId, params = {}) {
  const parameters = objectToParam(params);
  const { data } = await axios.get(
    `/registrations/${registrationId}/parking-requests?` + parameters
  );
  return data;
}

export async function getParkingRequest(registrationId, id) {
  const { data } = await axios.get(
    `/registrations/${registrationId}/parking-requests/` + id
  );
  return data;
}

export async function createParkingRequest(registrationId, values) {
  const { data } = await axios.post(
    `/registrations/${registrationId}/parking-requests`,
    values
  );
  return data;
}

export async function deleteParkingRequest(registrationId, id) {
  const { data } = await axios.delete(
    `/registrations/${registrationId}/parking-requests/` + id
  );
  return data;
}

export async function unclaimParking(eventId, id) {
  const { data } = await axios.post(
    `/events/${eventId}/parking-request-parking-stickers/${id}/unclaim`
  );
  return data;
}
